import firebase from 'firebase/app'
import "firebase/auth"
import "firebase/database"
import "firebase/storage"

var firebaseConfig = {
  apiKey: "AIzaSyDEOmw7GKAlNRb-jsG-MAH_kjhpnEeODNY",
  authDomain: "slack-chat-app-38fec.firebaseapp.com",
  databaseURL: "https://slack-chat-app-38fec.firebaseio.com",
  projectId: "slack-chat-app-38fec",
  storageBucket: "slack-chat-app-38fec.appspot.com",
  messagingSenderId: "893832983251",
  appId: "1:893832983251:web:c5f207f6b2764af0809a26",
  measurementId: "G-D9KZ78RSFX"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

  export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js